import { render, staticRenderFns } from "./ContributionConfirmationModal.vue?vue&type=template&id=30e210d0"
import script from "./ContributionConfirmationModal.vue?vue&type=script&lang=ts"
export * from "./ContributionConfirmationModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports